import GetAppIcon from '@material-ui/icons/GetApp'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import CloseIcon from '@mui/icons-material/Close'
import DeleteIcon from '@mui/icons-material/Delete'
import AttachmentIcon from '@mui/icons-material/Attachment'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Popover,
  List,
  ListItem,
  ListItemText,
  Badge,
  Box
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import moment from 'moment/moment'
import { useEffect, useRef, useState } from 'react'
import { getRequest } from '../../globalhelper/helper'
import {
  hideLoader,
  showAlert,
  showLoader
} from '../../redux/Common/commonActions'
import store from '../../store'

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1
})

function FSCP_Uploads() {
  const [Companies, setCompanies] = useState([])
  const [Company, setCompany] = useState('')
  const [From, setFrom] = useState('')
  const [To, setTo] = useState('')
  const [Reports, setReports] = useState([])

  const [selectedRow, setSelectedRow] = useState('')
  const [selectedRowData, setSelectedRowData] = useState({})
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [activeUploadCategory, setActiveUploadCategory] = useState(null)
  const [attachmentPopoverAnchor, setAttachmentPopoverAnchor] = useState(null)
  const [activeAttachmentRow, setActiveAttachmentRow] = useState(null)
  const [uploadCategories, setUploadCategories] = useState([])
  const [files, setFiles] = useState({})

  const handleOpenPopover = (event, categoryId) => {
    setSelectedRow('')
    setSelectedRowData({})
    setPopoverAnchor(event.currentTarget)
    setActiveUploadCategory(categoryId)
  };

  const handleClosePopover = () => {
    setPopoverAnchor(null)
    setActiveUploadCategory(null)
  };

  const handleOpenAttachmentPopover = (event, row) => {
    setAttachmentPopoverAnchor(event.currentTarget)
    setActiveAttachmentRow(row)
  }

  const handleCloseAttachmentPopover = () => {
    setAttachmentPopoverAnchor(null)
    setActiveAttachmentRow(null)
  }

  const activeCat = uploadCategories.find(c => c.id === activeUploadCategory);

  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(({ res }) => {
        setCompanies(
          (res.data || []).sort((a, b) =>
            (a.orgname || '').localeCompare(b.orgname || '')
          )
        )
      })
      .catch(err => console.log(err))
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFrom(firstDay)
    setTo(lastDay)

    getRequest('api/transactions/getAIReport')
      .then(({ res }) => {
        let Data = JSON.parse(res.data)
        setReports(Data || [])
        console.log(JSON.parse(res.data))
      })
      .catch(err => console.log(err))
  }, [])

  useEffect(() => {
    if (Company) {
      getRequest(
        `api/upload/UploadCredentials?orgid=${Company.orgid}&uploadType=AIUpload`
      ).then(({ res }) => {
        setUploadCategories(JSON.parse(res.data))
      })
    }
  }, [Company])

  const handleSelectRow = TransId => {
    if (selectedRow !== TransId) {
      setSelectedRowData(Reports.find(item => item.TransactionID === TransId))
      setSelectedRow(TransId)
    } else {
      setSelectedRowData({})
      setSelectedRow('')
    }
  }

  const handleReset = () => {
    setCompany('')
    var currentDate = moment()
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD')
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD')
    setFrom(firstDay)
    setTo(lastDay)
    setFiles([])
  }

  const handleSubmit = () => {
    store.dispatch(showLoader())
    setTimeout(() => {
      store.dispatch(hideLoader())
      store.dispatch(showAlert('File Upload Successfully', 'success'))
      setFiles({})
    }, 5000)
  }

  const downloadResultFile = async (fileName) => {
    try {
      let response = await getRequest(`api/upload/getAIResFile?fileName=${fileName}`)
      const data = response?.res?.data;
      if (!data) return;

      if (data.type === 'Buffer') {
        const byteArray = new Uint8Array(data.data)
        const contentType =
          response?.res?.headers?.['content-type'] || 'application/octet-stream'
        const fileExtensionMap = {
          'text/csv': '.csv',
          'application/pdf': '.pdf',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            '.xlsx',
          'application/zip': '.zip'
        }

        const extension = fileExtensionMap[contentType] || '.csv'
        const blob = new Blob([byteArray], { type: contentType })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = fileName.includes('.') ? fileName : fileName + extension
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } else if (typeof data === 'object' && !Array.isArray(data)) {
        // Handle multiple files object
        Object.keys(data).forEach((fileKey) => {
          const fileContent = data[fileKey];
          if (fileContent && fileContent.type === 'Buffer') {
            const byteArray = new Uint8Array(fileContent.data);
            const blob = new Blob([byteArray], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${fileKey}.xlsx`; // Adding the extension back since it was removed in backend
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        });
      }
    } catch (error) {
      console.log(error)
    }
  }

  const isReconcileDisabled =
    !Company ||
    !From ||
    !To ||
    (Object.values(files).every(arr => arr.length === 0));

  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
        >
          <Typography variant='h6'>FSCP Upload</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2}>
            <Grid item xs={3}>
              <Autocomplete
                size='small'
                fullWidth
                value={Company || null}
                options={Companies}
                getOptionLabel={option => option?.orgname || ''}
                isOptionEqualToValue={(option, value) =>
                  option.orgid === value?.orgid
                }
                onChange={(event, newValue) => setCompany(newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Company'
                    variant='outlined'
                    name='Company'
                  />
                )}
              />
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdFrom'
                  value={From}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    setFrom(newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='ForPrdTo'
                  value={To}
                  views={['day', 'month', 'year']}
                  onChange={newValue => {
                    setTo(newValue.format('YYYY-MM-DD'))
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid>
              <Button
                fullWidth
                variant='outlined'
                color='success'
                onClick={handleSubmit}
                disabled={isReconcileDisabled}
              >
                Submit
              </Button>
            </Grid>
            <Grid>
              <Button
                onClick={handleReset}
                fullWidth
                variant='outlined'
                color='error'
              >
                Reset
              </Button>
            </Grid>
          </Grid>
          <Grid container spacing={2} mt={2}>
            {uploadCategories.map(cat => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={cat.id} sx={{ display: 'flex' }}>
                <Badge badgeContent={files[cat.label]?.length} color="secondary" sx={{ width: '100%', '& .MuiBadge-badge': { zIndex: 1 } }}>
                  <Button
                    fullWidth
                    color="primary"
                    variant='contained'
                    startIcon={<CloudUploadIcon />}
                    onClick={(e) => handleOpenPopover(e, cat.id)}
                    sx={{ height: '100%', textTransform: 'none', py: 1, lineHeight: 1.2 }}
                  >
                    {cat.label}
                  </Button>
                </Badge>
              </Grid>
            ))}
          </Grid>

          <Popover
            open={Boolean(popoverAnchor)}
            anchorEl={popoverAnchor}
            onClose={handleClosePopover}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            {activeCat && (
              <Box sx={{ p: 2, minWidth: 300, maxWidth: 400 }}>
                <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                  {activeCat.label}
                </Typography>

                {files[activeCat.label]?.length > 0 ? (
                  <List dense sx={{ maxHeight: 200, overflow: 'auto', bgcolor: 'background.paper', border: '1px solid #e0e0e0', borderRadius: 1, mb: 2 }}>
                    {files[activeCat.label].map((file, index) => (
                      <ListItem
                        key={index}
                        secondaryAction={
                          <IconButton edge="end" aria-label="delete" size="small" onClick={() => {
                            setFiles(prev => ({ ...prev, [activeCat.label]: prev[activeCat.label].filter((_, i) => i !== index) }));
                          }}>
                            <DeleteIcon fontSize="small" color="error" />
                          </IconButton>
                        }
                      >
                        <ListItemText primary={file.name} secondary={`${(file.size / 1024).toFixed(2)} KB`} primaryTypographyProps={{ noWrap: true }} />
                      </ListItem>
                    ))}
                  </List>
                ) : (
                  <Typography variant="body2" color="textSecondary" mb={2}>No files selected.</Typography>
                )}

                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button variant="contained" component="label" size="small" fullWidth>
                    Add Files
                    <VisuallyHiddenInput
                      type="file"
                      multiple
                      accept={activeCat.accept}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          const newFiles = Array.from(e.target.files);
                          setFiles(prev => ({ ...prev, [activeCat.label]: newFiles }));
                          e.target.value = null;
                        }
                      }}
                    />
                  </Button>
                  {files[activeCat.label]?.length > 0 && (
                    <Button variant="outlined" color="error" size="small" onClick={() => setFiles({})} fullWidth>
                      Clear All
                    </Button>
                  )}
                </Box>
              </Box>
            )}
          </Popover>
        </AccordionDetails>
      </Accordion >
      {
        Reports.length > 0 && Company && (
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} size='small' aria-label='a dense table'>
              <TableHead>
                <TableRow>
                  <TableCell>Transaction ID</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>ForPrdFrom</TableCell>
                  <TableCell>ForPrdTo</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Uploaded Attachments</TableCell>
                  <TableCell>Download</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Reports?.map(item => (
                  <TableRow
                    key={item.TransactionID}
                    sx={
                      item.TransactionID === selectedRow
                        ? { backgroundColor: 'skyblue' }
                        : ''
                    }
                  >
                    <TableCell>{item.TransactionID}</TableCell>
                    <TableCell>{item.Date}</TableCell>
                    <TableCell>{item.ForPrdFrom}</TableCell>
                    <TableCell>{item.ForPrdTo}</TableCell>
                    <TableCell>{item.Type}</TableCell>
                    <TableCell>{item.Status}</TableCell>
                    <TableCell>
                      <IconButton size="small" color="primary" onClick={(e) => handleOpenAttachmentPopover(e, item)}>
                        <AttachmentIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant='text'
                        color='success'
                        disabled={!item?.["Output File"]}
                        onClick={() => downloadResultFile(item?.["Output File"])}
                      >
                        <GetAppIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      }
      <Popover
        open={Boolean(attachmentPopoverAnchor)}
        anchorEl={attachmentPopoverAnchor}
        onClose={handleCloseAttachmentPopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ p: 2, minWidth: 250, maxWidth: 400 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Uploaded Attachments
            </Typography>
            <IconButton size="small" onClick={handleCloseAttachmentPopover}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
          <List dense sx={{
            maxHeight: 300,
            overflow: 'auto',
            pr: 1,
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#e0e0e0',
              borderRadius: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#9e9e9e',
              borderRadius: '8px',
              border: '1px solid #e0e0e0',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#757575',
            }
          }}>
            {[
              "FIXED ASSET",
              "STOCK STATEMENT",
              "MOVEMENTS STATEMENT",
              "TRIAL BALANCE GL-WISE",
              "CRM Service & Revenue Operations"
            ].map((key, idx) => {
              if (activeAttachmentRow && activeAttachmentRow[key]) {
                return (
                  <ListItem key={idx} sx={{ py: 0.5, borderBottom: '1px solid #f0f0f0' }}>
                    <ListItemText
                      primary={key}
                      secondary={activeAttachmentRow[key]}
                      primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium' }}
                      secondaryTypographyProps={{ variant: 'caption', sx: { wordBreak: 'break-all' } }}
                    />
                  </ListItem>
                );
              }
              return null;
            })}
            {activeAttachmentRow && ![
              "STOCK STATEMENT",
              "FIXED ASSET",
              "MOVEMENTS STATEMENT",
              "TRIAL BALANCE GL-WISE",
              "CRM Service & Revenue Operations"
            ].some(key => activeAttachmentRow[key]) && (
                <Typography variant="body2" color="textSecondary" sx={{ py: 1 }}>
                  No attachments found.
                </Typography>
              )}
          </List>
        </Box>
      </Popover>
    </>
  )
}

export default FSCP_Uploads
